import type { FaireProductEntity } from "../../entity_types/product";

export const p_7t9mufwpmz: FaireProductEntity = {
  token: "p_7t9mufwpmz",
  type: "product",
  name: "Costa Rica Tarrazu San Diego Natural Whole Bean Coffee",
  brandToken: "b_f358njub53",
  brandName: "Comeback",
  imageUrl: "https://cdn.faire.com/fastly/f3622d3d028b0ea00a8db0fcdc13c4f83d1b910af87d8c9dd5d77c1f6bd4c350.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2362eb9c14bd18f3e2af9138ffb8ef1bdef50443a2a4c545ca5356ffe72528a4.webp",
    "https://cdn.faire.com/fastly/a9ddcf491a0c7ef7aa37c1fb655e384c89bec1cd2ded60979a3d7256b65d8d74.webp",
    "https://cdn.faire.com/fastly/3088c5e7576caffd12d125564acfb7665c24db3078dfb4a1669c4de6d194b4c7.jpeg"
  ],
  priceDollars: 15,
  description: "• Size: 10oz Retail Tin, 2lb Bags, 5lb Bags\n• Taste Notes: Mixed Berries, Earl Grey, Agave\n• Country: Costa Rica\n• Location: Terrazú\n• Elevation: 1500 MASL\n• Variety: F1\n• Processing: Natural\n\nOne of the most recognizable coffee-producing regions in Costa Rica, Tarrazú accounts for 25 percent of the country's total coffee production. Each coffee exported by CoopeTarrazú is cultivated at an elevation of 1,200 to 1,900 meters above sea level. Harvest coincides with the region's dry season, which lasts from November to March. This contributes not only to coffee uniformity but also the ability to process the coffee by sun-drying. We have absolutely fallen in love with the coffees coming from CoopeTarrazú.",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:44.062Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
